'use client';
import React from 'react';

import { AnnouncementBarResponseTypes } from '@src/graphql/queries.types';
import { GQL_FETCH_ANNOUNCEMENT_ENTRIES } from '@src/graphql/queries';
import { IS_PREVIEW, PAGE_LOCALES } from '@src/typescriptGlobals/constants';

import RenderBodyCopy from '../RenderBodyCopy';

import useEbookSlideAnimate from '@src/hooks/useEbookSlideAnimate';

import fetchContentfulProxy from '@src/utils/fetchContentfulProxy';

import { AnnouncementBarPropsTypes, AnnouncementTypes } from './AnnouncementBar.types';

const AnnouncementBar: React.FC<AnnouncementBarPropsTypes> = ({ params: { locale } }) => {
  const ebookSlideRef = useEbookSlideAnimate();
  const [eBooks, setEBooks] = React.useState<AnnouncementTypes>();

  React.useEffect(() => {
    fetchContentfulProxy<AnnouncementBarResponseTypes>({
      query: GQL_FETCH_ANNOUNCEMENT_ENTRIES?.loc?.source?.body ?? '',
      variables: {
        locale: PAGE_LOCALES.includes(locale) ? locale?.toUpperCase() : 'EN',
        preview: IS_PREVIEW,
      },
    }).then((res) => setEBooks(res.eBooks?.items?.[0]));
  }, []);

  const multipleEbook = eBooks?.topicCollection?.items?.length! > 1;

  return (
    <div
      ref={ebookSlideRef}
      id='announcement-bar'
      className={`bg-primary text-body-copy--light invisible absolute top-[7.4rem] z-[100] h-[5rem] w-full items-center justify-center gap-[0.4rem] overflow-hidden py-[1rem] text-center text-[1.6rem] font-[500] text-white shadow-lg sm:flex sm:h-[auto] [&_*_p]:text-left [&_*_p]:!leading-[1.6rem]`}
    >
      {eBooks?.title && (
        <p
          style={{ textShadow: 'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px' }}
          className={`self-center text-center ${multipleEbook ? 'sm:ml-[-24rem]' : ''}`}
        >
          {eBooks?.title}
        </p>
      )}

      <div
        className={`relative flex items-center text-center`}
        style={{ textShadow: 'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px' }}
      >
        {eBooks?.topicCollection?.items?.map((eBook) => {
          return (
            <RenderBodyCopy
              key={eBook?.sys?.id}
              bodyCopy={eBook?.bodyCopy?.json?.content}
              className={`text-body-copy--light [&>p>a]:!text-body-copy--light top-[1.8rem] mt-[-0.65rem] flex items-center justify-center underline hover:text-[#ECEAE8] sm:top-[unset] sm:left-[unset] sm:mt-[0] sm:justify-start [&>p>a]:text-[1.6rem] ${multipleEbook ? 'invisible absolute w-[100%] sm:w-[45rem]' : 'mt-[1rem] w-[100%] sm:mt-[unset] md:w-[unset] [&>p]:!w-[100%] [&>p]:!text-center md:[&>p]:!w-[unset]'}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementBar;
